// Шрифт сайта — со своего сервера (файлы попадают в сборку), без Google Fonts
import '@fontsource-variable/golos-text';
import { initGoogleAnalytics } from './src/utils/googleAnalytics';

export const onInitialClientRender = () => {
  // Инициализация Google Analytics
  initGoogleAnalytics('G-1LNJ3VFXLX');

  // Инициализация Яндекс Метрики
  if (typeof window !== 'undefined') {
    // Создаем функцию ym если её нет
    window.ym = window.ym || function () {
      (window.ym.a = window.ym.a || []).push(arguments);
    };
    window.ym.l = 1 * new Date();

    // Проверяем, не загружен ли уже скрипт
    const scriptAlreadyExists = Array.from(document.scripts).some(
      (script) => script.src === 'https://mc.yandex.ru/metrika/tag.js'
    );

    if (!scriptAlreadyExists) {
      // Создаем и загружаем скрипт
      const script = document.createElement('script');
      script.src = 'https://mc.yandex.ru/metrika/tag.js';
      script.async = true;
      
      // Инициализируем метрику после загрузки скрипта
      script.onload = () => {
        console.log('[metrika] tag.js loaded');
        window.ym(100666558, 'init', {
          defer: true,
          clickmap: true,
          trackLinks: true,
          accurateTrackBounce: true,
          webvisor: true
        });
      };

      document.head.appendChild(script);

      // Добавляем noscript для случаев без JavaScript
      const noscript = document.createElement('noscript');
      noscript.innerHTML = `
        <div>
          <img src="https://mc.yandex.ru/watch/100666558"
               style="position:absolute; left:-9999px;" alt="" />
        </div>`;
      document.body.appendChild(noscript);
    }
  }
};

export const onRouteUpdate = ({ location }) => {
  if (typeof window !== 'undefined' && typeof window.ym === 'function') {
    window.ym(100666558, 'hit', location.href, {
      title: document.title
    });
    console.log('[metrika] hit:', location.href);
  }
};

